module.exports = __webpack_public_path__ + "assets/task-connect.16136b59.svg";